export enum JinroPlayStatus {
  Day = "day",
  Vote = "vote",
  ExtraVote = "extravote",
  Execution = "execution",
  Night = "night",
  AfterNight = "afternight",
  Prologue = "prologue",
  Ending = "ending",
  NotDefined = "not-defined",
}
